import { FC } from "react";
import { Helmet } from "react-helmet";
import * as Sentry from "@sentry/react";
import { AllRoutes } from "~/AllRoutes";
import { useLoadCurrentUser } from "~/hooks/useLoadCurrentUser";
import { useVersionChanged } from "~/hooks/useVersionChanged";

const helmetProps = {
  titleTemplate: "%s | Conceive",
  defaultTitle: "Conceive",
};

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(AllRoutes);

export const App: FC = () => {
  useVersionChanged();
  const { hasLoadedInitial } = useLoadCurrentUser();

  if (!hasLoadedInitial) return null;

  return (
    <>
      <Helmet {...helmetProps}>
        <meta charSet="utf-8" />
        <html lang="en" />
      </Helmet>
      <SentryRoutes />
    </>
  );
};
